import { useMemo } from 'react';
import { Users } from 'lucide-react';
import type { MergedGuest } from './guestUtils';

interface Props {
  guests: MergedGuest[];
}

export default function GuestRepeatRate({ guests }: Props) {
  const { rate, repeatCount, total } = useMemo(() => {
    const guestTotal = guests.length;
    const guestRepeatCount = guests.filter((g) => g.totalReservations > 1).length;
    const guestRate = guestTotal > 0 ? (guestRepeatCount / guestTotal) * 100 : 0;
    return { rate: guestRate, repeatCount: guestRepeatCount, total: guestTotal };
  }, [guests]);

  return (
    <div className="bg-card rounded-lg border p-4 md:p-6 flex flex-col justify-center min-w-0">
      <div className="flex items-center gap-2 mb-3">
        <div className="h-8 w-8 rounded-md bg-primary/10 flex items-center justify-center">
          <Users className="h-4 w-4 text-primary" />
        </div>
        <span className="text-sm font-medium text-muted-foreground">Repeat Guest Rate</span>
      </div>
      <div className="text-3xl font-bold tracking-tight">{rate.toFixed(1)}%</div>
      <p className="text-sm text-muted-foreground mt-1">
        {repeatCount} of {total} guest{total !== 1 ? 's' : ''} returned
      </p>
      <div className="mt-3 h-2 w-full rounded-full bg-muted overflow-hidden">
        <div
          className="h-full rounded-full bg-primary transition-all"
          style={{ width: `${Math.min(rate, 100)}%` }}
        />
      </div>
    </div>
  );
}
